import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { SaleListContext } from '../../../SaleListContext';


export function SaleListDetailPurchasePlus(props: any) {

  const isPaid = props.isPaid;

  const isPc = useContext(cmnContext).isPc;

  const userOrg = useContext(SaleListContext).userOrg;
  const SUBSCRIPTION_NAME = useContext(SaleListContext).SUBSCRIPTION_NAME;


  return (
    <div className="text-center" style={{width: '100%'}}>

      {/* チケット・購入不可の場合 */}
      {!isPaid &&
        <p style={{
          fontSize: isPc? '100%' : '100%',
          fontWeight: 'bold',
          alignSelf: 'center',
        }}>
          {userOrg.is_subscription=='0' ?
            `本コンテンツのご利用は${SUBSCRIPTION_NAME}へのご加入が必要です。`
          :
            <>
            {userOrg.old_subscription!='0' &&
              `本コンテンツのご利用は${SUBSCRIPTION_NAME}の新プランへ切り替えが必要です。`
            }
            </>
          }
        </p>
      }

      <div
       className="text-center"
       style={{
          padding: (isPc && isPaid)? '10px 20px' : 0,
       }}
      > 
        <a
          href="/settlement/extension?target=subscription#subscription"
          className="btn btn-danger btn_customize"
          style={{
            width: isPaid? '100%' : 'auto',
            padding: (!isPc && isPaid)? '5px 8px' : '10px 15px',
          }}
        >
          {SUBSCRIPTION_NAME} <i className="fas fa-chevron-circle-right"></i>
        </a>
      </div>

    </div>
  );
}